import EnrollmentError from './EnrollmentError';

class TraderProfileError extends EnrollmentError {
  constructor(code, details = null) {
    super(code, 'TraderProfileError', details);
  }
}

export default TraderProfileError;
